const doc = [({"en":({"js":({"admin":({"steps":({"updated_element_positions":"Updated element position", "create":"Create element"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;